module.exports = "/static/assets/1b25f57863d78566f7c430953d5498da.png";